<template>
  <div></div>
</template>
<script>
export default {
  name: "AuthEkyzmat",
  created() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'code')
        && Object.prototype.hasOwnProperty.call(this.$route.query, 'state')) {

      let params = {
        code: this.$route.query.code,
        state: this.$route.query.state,
        redirect_uri: window.location.origin + '/auth-ekyzmat'
      };

      this.$store
          .dispatch("loginWithEkyzmat", params)
          .then(() => {
            if(this.$store.getters.getAttemptUrl) {
              this.$router.push(this.$store.getters.getAttemptUrl)
              this.$store.commit('setAttemptUrl', null)
            } else {
              if(this.$store.getters.isAdmin) {
                return this.$router.push({name: 'Admin'})
              } else {
                return this.$router.push({name: 'EmployeeApplicationsList'})
              }
            }
          })
          .catch((err) => {
            console.log(err);
          })
    }
  },
};
</script>
